// extracted by mini-css-extract-plugin
export default {"back-button":"back-button-fb878073","backButton":"back-button-fb878073"};